import React from "react";
import Template from "../../components/template";
import CardWithHeaderTemplate from "../../components/cardWithHeaderTemplate";
import Table from "./components/table";
import HeaderView from "./components/headerView";
import PaginationView from "./components/paginationView";
const Html = () => {
    return(
        <Template>
            <div className="container-fluid py-4">
                <div className="row">
                    <div className="col-12">
                        <CardWithHeaderTemplate
                            header={<HeaderView/>} 
                            body={<Table/>} 
                            footer={<PaginationView/>}
                        />
                    </div>
                </div>
            </div>
        </Template>
    );
}

export default Html;